import type { FC } from 'react';
import React from 'react';
import {
  Body,
  Box,
  Col,
  FlexRow,
  Glyph,
} from '@edreamsodigeo/prisma-design-system';

import { Duration } from './Duration';

interface DurationWithIconProps {
  duration: number;
  color?: 'neutrals.1' | 'neutral.80';
  type: 'base';
  weight: 'medium' | 'normal';
}

export const DurationWithIcon: FC<DurationWithIconProps> = ({
  duration,
  color,
  type,
  weight,
}) => {
  return (
    <FlexRow flexDirection="row" alignItems="center" gap="1">
      <Col>
        <Box mr="minus_2x_small">
          <Glyph
            size="small"
            color={color}
            category="TimeAndDates"
            name="Time"
          />
        </Box>
      </Col>
      <Col>
        <Body type={type} color={color as string} weight={weight}>
          <Duration durationInMinutes={duration} />
        </Body>
      </Col>
    </FlexRow>
  );
};
